var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ma-0"},[_c('v-col',{staticClass:"page-header elevation-1 white"},[_c('h1',{staticClass:"text-center my-sm-3 text-big-title text-sm-huge-title text-md-massive-title"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }